// extracted by mini-css-extract-plugin
export default {"root":"uW7L5cAl0DXXP8W_5XbP","active":"aJRAT2vgqw5VL4kgkv5c","placeHolderShimmer":"n4slHUMsfHf821DajjLr"};